<template>
  <div class="q-pl-sm q-pr-md q-pb-xs full-width attendance-mail-item">
    <q-expansion-item
      v-model="isOpen"
      expand-icon-toggle
      expand-icon-class="hidden"
      :class="['overflow-hidden', isOpen ? 'shadow-1' : '']"
      :icon="`${ message.direction === 'OUT' ? 'mdi-email-receive-outline' : 'mdi-email-send-outline' }`"
      :style="`border-radius: 17px; background: ${colorMessage}`"
    >
      <template #header>
        <div class="row full-width full-height">
          <div
            class="col-auto q-pr-sm"
            v-if="$scopedSlots['prefix-head']"
          >
            <slot name="prefix-head" />
          </div>

          <div
            :data-testid="`email-item-expandir-${message.id}`"
            class="col cursor-pointer tw-min-w-0 [overflow-wrap:anywhere]"
            @click="isOpen = !isOpen"
          >
            {{ labelMessage(message) }}
          </div>

          <div
            v-if="isPending"
            class="col-auto text-red-7 q-mr-md"
          >
            Pendente
          </div>

          <div
            :data-testid="`email-item-abrir-perfilador-${message.id}`"
            class="col-auto cursor-pointer q-mr-md"
            @click="$emit('click-open-profiler', labelMessage(message))"
          >
            <q-icon
              name="mdi-clipboard-edit-outline"
              color="primary"
            >
              <q-tooltip>Abrir perfilador</q-tooltip>
            </q-icon>
          </div>

          <div
            :data-testid="`email-item-expandir-icone-${message.id}`"
            class="col-auto cursor-pointer"
            @click="isOpen = !isOpen"
          >
            <q-icon
              :name="`${ message.direction === 'OUT' ? 'mdi-email-receive-outline' : 'mdi-email-send-outline'}`"
              size="xs"
              color="primary"
            >
              <q-tooltip>
                {{ message.direction === "OUT" ? "Mensagem Ativa" : "Mensagem Receptiva"
                }}<q-tooltip />
              </q-tooltip>
            </q-icon>
          </div>
        </div>
      </template>

      <q-card>
        <q-card-section>
          <div
            v-if="message.mailBody"
            v-html="message.mailBody"
            class="mail-body"
          />
          <div
            v-else
            class="row full-height items-center"
          >
            <div class="col-auto q-mx-auto q-my-auto">
              <q-spinner-ios
                color="primary"
                size="3em"
              />
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-expansion-item>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment-timezone'

export default {
  props: {
    message: {},
    defaultOpened: {},
    isHistoryEmail: {
      default: false
    }
  },

  data () {
    return {
      isOpen: false,
      isLoading: false
    }
  },

  mounted () {
    const vm = this

    if (vm.defaultOpened) {
      vm.$nextTick().then(() => {
        vm.isOpen = true
      })
    }
  },

  computed: {
    ...mapState({
      isPending ({ attendanceModule }) {
        const { emailAttendanceId, id } = this.message
        if (!attendanceModule.profilersEmail[emailAttendanceId]) return
        const profiler = attendanceModule.profilersEmail[emailAttendanceId][id]
        if (!profiler) return
        return profiler.isSaved === false
      }
    }),

    colorMessage () {
      const { status, direction } = this.message

      if (direction === 'OUT') {
        if (status === 'SEND_FAILED') return '#fdbfbfb5'
        if (status === 'SEND_PENDING') return '#ffc18191'
        return '#7eb57991'
      }

      return '#bfe3fd'
    }
  },

  methods: {
    ...mapActions({
      loadBodyMessage: 'attendanceModule/loadBodyMessage'
    }),

    labelMessage (msg) {
      const mNow = moment()
      const mCreatedAt = moment.unix(msg.createdAt)
      const msgDate = mCreatedAt.format('DD/MM/YY')
      const msgHours = mCreatedAt.format('HH:mm:ss')
      const isToday = msgDate === mNow.format('DD/MM/YY')
      const isYesterday = msgDate === mNow.add(-1, 'days').format('DD/MM/YY')
      const prefix = isToday
        ? 'hoje'
        : isYesterday
          ? 'ontem'
          : `em ${mCreatedAt.format('DD/MM')}`
      const datetime = `${prefix} às ${msgHours}`

      if (msg.status === 'SEND_FAILED') return `Falha no envio desde ${datetime} - Agente ${msg.agentName} #${msg.agentId} - Destinatário: ${msg.to[0].id}`
      if (msg.status === 'SEND_PENDING') return `Pendente de envio desde ${datetime} - Agente ${msg.agentName} #${msg.agentId} - Destinatário: ${msg.to[0].id}`

      if (msg.direction === 'IN') return `Recebida ${datetime} - ${msg.mailFrom}`
      return `Enviada ${datetime} - Agente ${msg.agentName} #${msg.agentId} - Destinatário: ${msg.to[0].id}`
    },

    checkLoadBody () {
      const vm = this
      if (vm.isLoading) return
      if (vm.message.mailBody) return
      vm.isLoading = true
      const { id: messageId, emailAttendanceId: attendanceId } = vm.message
      vm.loadBodyMessage({ messageId, attendanceId })
    }
  },

  watch: {
    isOpen (isOpen) {
      if (!isOpen) return
      this.checkLoadBody()
    },

    'message.id' (newId, oldId) {
      if (newId === oldId) return
      this.isLoading = false
      this.checkLoadBody()
    }
  }
}
</script>

<style lang="sass">
.attendance-mail-item
  .q-item
    height: auto
    min-height: auto

  .q-expansion-item--collapsed
    .q-item
      border-radius: 20px

  .q-expansion-item--expanded
    .q-item
      border-radius: 20px 20px 0 0

.mail-body
  overflow-wrap: anywhere
  img, table
    max-width: 100%
</style>
